// ThemedCheckoutButton.jsx - Reusable checkout button with theme
import React from "react";

const ThemedCheckoutButton = ({
  theme,
  href = "/cart/",
  text = "Checkout",
}) => {
  const baseClass = `px-6 py-2 font-extralight disabled:opacity-50 disabled:cursor-not-allowed ${
    theme === "pink"
      ? "text-pink-primary-600 border rounded-full border-pink-primary-600 hover:text-white hover:bg-pink-primary-600 transition-all"
      : "bg-blue-sky-500 hover:bg-blue-sky-400"
  }`;

  return (
    <a href={href}>
      <button className={baseClass}>{text}</button>
    </a>
  );
};

export default ThemedCheckoutButton;